import _objectSpread from "C:\\a\\2\\s\\Programs\\Microservices.Common.Frontend\\ecrion-components\\node_modules\\babel-preset-react-app\\node_modules\\@babel\\runtime/helpers/esm/objectSpread"; //@ts-check

import defaultName from './default';
import workspaceName from './workspaceName';
import communicationName from './communicationName';
import projectName from './projectName';
import folderPath from './folderPath';
import folderName from './folderName';
import trackingName from './trackingName';
import formName from './formName';
import fileName from './fileName';
import fileLabel from './fileLabel';
import firstName from './firstName';
import lastName from './lastName';
import organizationName from './organizationName';
import groupName from './groupName';
import userName from './userName';
import appCategoryName from './appCategoryName';
import ecrionFormDataLabel from './ecrionFormDataLabel';
import ecrionFormDataDescription from './ecrionFormDataDescription';
import email from './email';
import validator from './validator';
export var validators = {
  workspaceName: workspaceName,
  projectName: projectName,
  communicationName: communicationName,
  folderPath: folderPath,
  folderName: folderName,
  trackingName: trackingName,
  formName: formName,
  fileName: fileName,
  fileLabel: fileLabel,
  firstName: firstName,
  lastName: lastName,
  organizationName: organizationName,
  groupName: groupName,
  userName: userName,
  appCategoryName: appCategoryName,
  ecrionFormDataLabel: ecrionFormDataLabel,
  ecrionFormDataDescription: ecrionFormDataDescription,
  email: email
};
/**
 * @param {import('./types').FormFieldValidatorType} type
 * @returns {import('./types').FormFieldValidator<any>}
 */

var ofType = function ofType(type) {
  return function (value) {
    if (type && validators[type]) return validators[type](value);
    return defaultName(value);
  };
};

export default _objectSpread({
  ofType: ofType,
  default: defaultName
}, validator, validators);